import React, { Component } from 'react';

import { connect } from 'react-redux';
import * as vanillaDesignActions from '../../../redux/vanillaDesignActions';
import { bindActionCreators } from 'redux';

import './VanillaFinalCheck.scss';
import { string } from '../../../localization';
import * as Constants from '../../../utilities/constants/Constants';
import { Icons } from '../../../utilities';
import { getPremiumContentFolderTitle } from '../../../redux/sideBarActionHelpers';
import * as api from '../../../services/api';
import ReactSelect from 'react-select';

class PremiumContentRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      password: '',
      confirmPassword: '',
      company: '',
      fiscalNumber: '',
      streetAddress: '',
      areaCode: '',
      city: '',
      website: '',
      firstName: '',
      lastName: '',
      position: '',
      email: '',
      phone: '',
      mobile: '',
      countriesLists: [],
      checkedNewsLetter: false,
      checkedAuthorize: '',
      salutations: [
        { value: 'Ms.', label: 'Ms' },
        { value: 'Mr.', label: 'Mr' }
      ],
      selectedOption: null,
      selectedCountry: null,
      selectedOptionValue: ''
    };
  }

  componentDidMount() {
    api
      .getCountryList()
      .then(responseData => {
        this.setState({
          countriesLists: responseData.data.countries
        });
      })
      .catch(() => {});
  }

  openRegisterModal = () => {};

  closeRegisterModal = () => {};

  openLogin = () => {};

  createAccount = () => {
    const {
      userName,
      password,
      confirmPassword,
      company,
      fiscalNumber,
      streetAddress,
      areaCode,
      city,
      selectedCountry,
      website,
      selectedOptionValue,
      firstName,
      lastName,
      position,
      email,
      phone,
      mobile,
      checkedNewsLetter,
      checkedAuthorize
    } = this.state;

    const { contentType, dispatchers, patternDesignRegisterError } = this.props;
    const userData = {
      username: userName,
      password,
      password_confirmation: confirmPassword,
      company,
      vatNumber: fiscalNumber,
      street: streetAddress,
      zipCode: areaCode,
      city,
      country: selectedCountry,
      website,
      salutation: selectedOptionValue,
      firstName,
      lastName,
      position,
      email,
      phone,
      mobile,
      newsletter: checkedNewsLetter,
      authorize_hp: checkedAuthorize
    };

    if (contentType == Constants.PATTERN_DESIGN_IMAGE_SOURCE) {
      dispatchers.vanillaDesignActions.registerAccount(userData);
    } else {
      dispatchers.vanillaDesignActions.registerDreamstimeAccount(userData);
    }

    if (patternDesignRegisterError) {
      document.getElementById('scrollUp').scrollIntoView();
    }
  };

  clearRegisterAccountDetails = () => {
    this.setState({
      userName: '',
      password: '',
      confirmPassword: '',
      company: '',
      fiscalNumber: '',
      streetAddress: '',
      areaCode: '',
      city: '',
      selectedCountry: '',
      website: '',
      selectedOptionValue: '',
      firstName: '',
      lastName: '',
      position: '',
      email: '',
      phone: '',
      mobile: '',
      checkedNewsLetter: '',
      checkedAuthorize: ''
    });
  };

  countrySelectorHandler = value => {
    this.setState({
      selectedCountry: value.value.id
    });
  };

  isCheckBoxSelectedNewsLetter = () => {
    this.setState(prevState => ({
      checkedNewsLetter: !prevState.checkedNewsLetter
    }));
  };

  isCheckBoxSelectedAuthorize = () => {
    const { checkedAuthorize } = this.state;
    if (!checkedAuthorize) {
      this.setState({
        checkedAuthorize: 'true'
      });
    } else {
      this.setState({
        checkedAuthorize: 'false'
      });
    }
  };

  salutationSelectorHandler = selectedOption => {
    this.setState({
      selectedOption,
      selectedOptionValue: selectedOption.value
    });
  };

  handleRegisterModal = contentType => {
    const { closeRegisterModal } = this.props;
    if (contentType == Constants.PATTERN_DESIGN_IMAGE_SOURCE) {
      closeRegisterModal(false, Constants.PATTERN_DESIGN_IMAGE_SOURCE);
    } else {
      closeRegisterModal(false, Constants.DREAMSTIME_IMAGE_SOURCE);
    }
    this.clearRegisterAccountDetails();
  };

  render() {
    const {
      userName,
      password,
      confirmPassword,
      company,
      fiscalNumber,
      streetAddress,
      areaCode,
      city,
      website,
      firstName,
      lastName,
      position,
      email,
      phone,
      mobile,
      checkedNewsLetter,
      checkedAuthorize,
      countriesLists,
      selectedOption,
      salutations
    } = this.state;

    const { patternDesignRegisterError, dispatchers } = this.props;

    const countries = countriesLists;
    const countriesArray = [];
    Object.keys(countries).forEach(key => {
      const newCountry = {};
      newCountry.value = countries[key];
      newCountry.label = countries[key].name;
      countriesArray.push(newCountry);
    });

    const { contentType } = this.props;

    return (
      <div>
        <div>
          <div className='closeModalIcn'>
            <button
              type='button'
              style={{ border: 'none', background: 'none', outline: 'none' }}
              onClick={() => this.handleRegisterModal(contentType)}
            >
              <img
                className='closeModalRegister'
                src={Icons.close}
                alt='close'
              />
            </button>
          </div>
          <div>
            <div>
              <p className='registerHeader'>
                {string.formatString(
                  string.REGISTER_TO,
                  getPremiumContentFolderTitle(contentType)
                )}
              </p>
            </div>

            <div className='registerBody'>
              {contentType == Constants.PATTERN_DESIGN_IMAGE_SOURCE ? (
                <div>
                  <span className='registerSubHeader'>
                    {string.REGISTER_PATTERNSUB1}
                  </span>
                  <span className='registerSubHeaderBold'>
                    {string.formatString(
                      string.REGISTER_PATTERNSUB2,
                      getPremiumContentFolderTitle(contentType)
                    )}
                  </span>{' '}
                  <br />
                  <span className='registerSubHeader'>
                    {string.formatString(
                      string.REGISTER_PATTERNSUB3,
                      getPremiumContentFolderTitle(contentType)
                    )}
                  </span>{' '}
                </div>
              ) : null}
              <div id='scrollUp'>
                <ul>
                  {patternDesignRegisterError.map(item => (
                    <li>{item}</li>
                  ))}
                </ul>
              </div>

              <div className='borderBottomRegister'>
                <span className='registerInfoText'>{string.REGISTER_INFO}</span>
              </div>

              <div className='formContainer'>
                <div className='formLeft'>
                  <div className='requiredFields'>
                    <span className='requiredMark'> {Constants.ASTERISK}</span>{' '}
                    <span className='required-txt'>
                      {string.REQUIRED_FIELDS_TEXT_KEY}
                    </span>
                  </div>
                  <div className='formBottomMargin countryLists'>
                    <div className='labelContainer'>
                      <label htmlFor='userName'>{string.USER_NAME}</label>
                      <span className='requiredMark'>*</span>
                    </div>
                    <input
                      type='text'
                      name='userName'
                      value={userName}
                      onChange={event => {
                        this.setState({
                          userName: event.target.value
                        });
                      }}
                    />
                  </div>

                  <div className='formBottomMargin countryLists'>
                    <div className='labelContainer'>
                      <label htmlFor='passWord'>{string.PASSWORD_KEY}</label>
                      <span className='requiredMark'>*</span>
                    </div>
                    <input
                      type='password'
                      name='password'
                      value={password}
                      onChange={event => {
                        this.setState({
                          password: event.target.value
                        });
                      }}
                    />
                  </div>

                  <div className='formBottomMargin countryLists'>
                    <div className='labelContainer'>
                      <label htmlFor='confirmPassword'>
                        {string.CONFIRM_PASSWORD}
                      </label>
                      <span className='requiredMark'>*</span>
                    </div>
                    <input
                      type='password'
                      name='confirmPassword'
                      value={confirmPassword}
                      onChange={event => {
                        this.setState({
                          confirmPassword: event.target.value
                        });
                      }}
                    />
                  </div>

                  {contentType == Constants.PATTERN_DESIGN_IMAGE_SOURCE ? (
                    <div>
                      <div className='borderBottomCompanyInfo'>
                        <span>{string.REGISTER_COMPANYINFO}</span>
                      </div>
                      <div className='formBottomCompany countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='company'>{string.COMPANY}</label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <input
                          type='text'
                          name='lastname'
                          value={company}
                          onChange={event => {
                            this.setState({
                              company: event.target.value
                            });
                          }}
                        />
                      </div>
                      <div className='formBottomMargin countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='fiscNum'>{string.FISCAL_NUM}</label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <input
                          type='text'
                          name='fiscNumber'
                          value={fiscalNumber}
                          onChange={event => {
                            this.setState({
                              fiscalNumber: event.target.value
                            });
                          }}
                        />
                      </div>
                      <div className='formBottomMargin countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='streetAddress'>
                            {string.STREET_ADD}
                          </label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <input
                          type='text'
                          name='streetAddress'
                          value={streetAddress}
                          onChange={event => {
                            this.setState({
                              streetAddress: event.target.value
                            });
                          }}
                        />
                      </div>
                      <div className='formBottomMargin countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='areaCode'>{string.AREA_CODE}</label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <input
                          type='text'
                          name='areaCode'
                          value={areaCode}
                          onChange={event => {
                            this.setState({
                              areaCode: event.target.value
                            });
                          }}
                        />
                      </div>
                      <div className='formBottomMargin countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='city'>{string.CITY}</label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <input
                          type='text'
                          name='city'
                          value={city}
                          onChange={event => {
                            this.setState({
                              city: event.target.value
                            });
                          }}
                        />
                      </div>
                      <div className='formBottomMargin countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='country'>{string.COUNTRY}</label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <ReactSelect
                          options={countriesArray}
                          onChange={e => this.countrySelectorHandler(e)}
                          placeholder={
                            <div className='countryPlaceholder'>
                              {string.SELECT_COUNTRY}
                            </div>
                          }
                          styles={{
                            control: base => ({
                              ...base,
                              '&:hover': { borderColor: 'gray' },
                              border: '1px solid rgb(128, 128, 128)',
                              borderRadius: '0px',
                              boxShadow: 'none',
                              width: '210px',
                              borderRight: '1px solid rgb(128, 128, 128)'
                            })
                          }}
                        />
                      </div>
                      <div className='formBottomMargin countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='website'>{string.WEBSITE}</label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <input
                          type='text'
                          name='website'
                          value={website}
                          onChange={event => {
                            this.setState({
                              website: event.target.value
                            });
                          }}
                        />
                      </div>

                      <div className='borderBottomCompanyInfo'>
                        <span>{string.REGISTER_CONTACTINFO}</span>
                      </div>
                      <div className='formBottomCompany countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='salutation'>
                            {string.SALUTATION}
                          </label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <ReactSelect
                          value={selectedOption}
                          options={salutations}
                          onChange={e => this.salutationSelectorHandler(e)}
                          placeholder={
                            <div className='countryPlaceholder'>
                              {string.SELECT_SALUTATION}
                            </div>
                          }
                          styles={{
                            control: base => ({
                              ...base,
                              '&:hover': { borderColor: 'gray' },
                              border: '1px solid rgb(128, 128, 128)',
                              borderRadius: '0px',
                              boxShadow: 'none',
                              width: '210px',
                              borderRight: '1px solid rgb(128, 128, 128)'
                            })
                          }}
                        />
                      </div>
                      <div className='formBottomMargin countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='firstName'>{string.FIRSTNAME}</label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <input
                          type='text'
                          name='firstName'
                          value={firstName}
                          onChange={event => {
                            this.setState({
                              firstName: event.target.value
                            });
                          }}
                        />
                      </div>
                      <div className='formBottomMargin countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='lastName'>{string.LASTNAME}</label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <input
                          type='text'
                          name='lastName'
                          value={lastName}
                          onChange={event => {
                            this.setState({
                              lastName: event.target.value
                            });
                          }}
                        />
                      </div>
                      <div className='formBottomMargin countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='position'>{string.POSITION}</label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <input
                          type='text'
                          name='position'
                          value={position}
                          onChange={event => {
                            this.setState({
                              position: event.target.value
                            });
                          }}
                        />
                      </div>
                    </div>
                  ) : null}
                  <div className='formBottomMargin countryLists'>
                    <div className='labelContainer'>
                      <label htmlFor='email'>{string.EMAIL_KEY}</label>
                      <span className='requiredMark'>*</span>
                    </div>
                    <input
                      type='text'
                      name='email'
                      value={email}
                      onChange={event => {
                        this.setState({
                          email: event.target.value
                        });
                      }}
                    />
                  </div>
                  {contentType == Constants.PATTERN_DESIGN_IMAGE_SOURCE ? (
                    <div>
                      <div className='formBottomMargin countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='phone'>{string.PHONE}</label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <input
                          type='text'
                          name='phone'
                          value={phone}
                          onChange={event => {
                            this.setState({
                              phone: event.target.value
                            });
                          }}
                        />
                      </div>
                      <div className='formBottomMargin countryLists'>
                        <div className='labelContainer'>
                          <label htmlFor='mobile'>{string.MOBILE}</label>
                          <span className='requiredMark'>*</span>
                        </div>
                        <input
                          type='text'
                          name='mobile'
                          value={mobile}
                          onChange={event => {
                            this.setState({
                              mobile: event.target.value
                            });
                          }}
                        />
                      </div>
                      <div className='checkBoxContainer'>
                        <input
                          className='checkBox'
                          type='checkbox'
                          defaultChecked={checkedNewsLetter}
                          onChange={this.isCheckBoxSelectedNewsLetter}
                        />
                        <span className='checkBoxContent'>
                          {string.CHECKBOX_CONTENT1}
                        </span>
                      </div>
                      <div className='checkBoxContainer'>
                        <input
                          className='checkBox'
                          type='checkbox'
                          defaultChecked={checkedAuthorize}
                          onChange={this.isCheckBoxSelectedAuthorize}
                        />
                        <span className='checkBoxContent'>
                          {string.CHECKBOX_CONTENT2}
                        </span>
                        <span className='requiredMark'>*</span>
                      </div>
                    </div>
                  ) : null}
                  <div className='createAccountBtnContainer'>
                    <div
                      role='button'
                      tabIndex='0'
                      className='createAccountBtn'
                      onClick={this.createAccount}
                      onKeyPress={() => {}}
                    >
                      {string.CREATE_ACCOUNT}
                    </div>
                  </div>
                </div>

                <div className='formRight'>
                  <button
                    type='button'
                    style={{
                      border: 'none',
                      background: 'none',
                      outline: 'none'
                    }}
                    onClick={
                      contentType == Constants.PATTERN_DESIGN_IMAGE_SOURCE
                        ? () =>
                            dispatchers.vanillaDesignActions.handlePatternDesignLoginWindow(
                              true
                            )
                        : () =>
                            dispatchers.vanillaDesignActions.handleDreamstimeLoginWindow(
                              true
                            )
                    }
                  >
                    <span className='alreadyAccount'>
                      {string.formatString(
                        string.ALREDY_HAVE_AN_ACCOUNT,
                        getPremiumContentFolderTitle(contentType)
                      )}
                      {/* {contentType == Constants.PATTERN_DESIGN_IMAGE_SOURCE
                        ?   string.ALREDY_HAVE_AN_ACCOUNT
                        : string.ALREADY_HAVE_AN_DREAMSTIME_ACCOUNT} */}
                    </span>
                    <button type='button' className='loginBtn'>
                      {string.LOGIN_NOW}
                    </button>
                  </button>

                  <div className='patternDesignContainer'>
                    <div className='patternDesignTxt'>
                      <img
                        className='mb-3'
                        src={
                          contentType == Constants.PATTERN_DESIGN_IMAGE_SOURCE
                            ? Icons.patternDesignTitleImage
                            : Icons.dreamstime_login_logo_lite
                        }
                        alt='imageSource'
                      />
                      <div>
                        <span className='description title'>
                          {string.HIGH_QUALITY_KEY}
                        </span>{' '}
                        <span className='description sub-title'>
                          {string.AND_KEY}
                        </span>{' '}
                        <br />
                        <span className='description title pattern-txt'>
                          {string.ROYALTY_FREE_KEY}
                        </span>{' '}
                        {contentType ==
                        Constants.PATTERN_DESIGN_IMAGE_SOURCE ? (
                          <span className='description sub-title'>
                            {string.SEAMLESS_KEY}
                          </span>
                        ) : null}
                        <br />
                        {contentType ==
                        Constants.PATTERN_DESIGN_IMAGE_SOURCE ? (
                          <span className='description title'>
                            {string.VECTOR_KEY}
                          </span>
                        ) : null}{' '}
                        <span
                          className={
                            contentType == Constants.PATTERN_DESIGN_IMAGE_SOURCE
                              ? 'description sub-title'
                              : 'description title'
                          }
                        >
                          {contentType == Constants.PATTERN_DESIGN_IMAGE_SOURCE
                            ? string.PATTERNS_FOR_KEY
                            : string.DREAMSTIME_IMAGES_KEY}
                        </span>
                        {!contentType ==
                        Constants.PATTERN_DESIGN_IMAGE_SOURCE ? (
                          <span className='description sub-title'>
                            {string.FOR_KEY}
                          </span>
                        ) : null}
                        <br />
                        <span className='description title profesion-txt'>
                          {string.PROFESSIONAL_USE_TITLE_KEY}
                        </span>{' '}
                      </div>
                    </div>

                    <div className='designImage'>
                      <img
                        className='mb-3'
                        src={
                          contentType == Constants.PATTERN_DESIGN_IMAGE_SOURCE
                            ? Icons.patternDesignRegister
                            : Icons.dreamstime_login_icon
                        }
                        alt='imageSource'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    patternDesignRegisterError: state.vanilla.registerError
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      vanillaDesignActions: bindActionCreators(vanillaDesignActions, dispatch)
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PremiumContentRegister);
